/* eslint-disable complexity */
/* eslint-disable max-statements */
import React, {useState, useEffect} from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import InfoIcon from "./images/info-icon.svg";
import { getFullCarName, getPersonalisedTooltipInfoList, getTooltipInfoList } from "../../../utils/helpers/car-properties";
import { makeOdometerLabelAU } from "../../../utils/helpers/make-odometer-label";
import { makePriceLabelRound } from "../../../utils/helpers/make-price-label";
import Tooltip from "../../shared/tooltip";
import Button from "../../shared/button";
import { useHistory } from "react-router-dom";
import WhiteTickIcon from "./../../shared/images/white-tick.svg";
import TradeInYourCarToggleButtonRevamp from "../trade-in-your-car-toggle-button-revamp";
import { getCarPrice } from "../../../utils/helpers/calculate-egc-dap";

const VehicleInfoSection = ({
    content,
    deliveryInfo,
    order,
    userTradeInData,
    tradeInToggleSelected,
    isUserZeroDpVariant,
    carId
}) => {
    const [toolTipTitle, setToolTipTitle] = useState("");
    const [toolTipBody, setToolTipBody] = useState([]);
    const {  price, egc, variant, bodyType, transmissionType, odometerReading, emiDetails, personalised  } = content || {};
    const { tradeIn = false, tradeInAmount } = userTradeInData || {};
    const { shippingPrice = 0, pickupCharges } = deliveryInfo || {};
    const {deliveryMode} = order || {};
    const { emiPerWeek } = emiDetails || {};
    const carName = getFullCarName(content);
    const history = useHistory();
    const handleGetPreApprovalClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        history.push("/financing/get-pre-approval");
    };
    const carPrice = getCarPrice({ egcPrice: egc, dapPrice: price, shippingPrice, pickupCharges, deliveryMode }).egc;
    const tradeCarPrice = carPrice.value > tradeInAmount  ?  carPrice.value - tradeInAmount : 0;
    const BottomLink = () => {
        return (
            <div
                styleName={"styles.tooltipBottomURL"}>
                <span>Want to know your exact finance rates?</span>
                <Button text="GET PRE-APPROVAL"
                    leftImage={WhiteTickIcon}
                    onClick={handleGetPreApprovalClick}
                    btnView="new" />
                <small>No impact on your credit score</small>
            </div>
        );
    };

    useEffect(() => {
        if (personalised) {
            setToolTipTitle(`Weekly payment of ${makePriceLabelRound(emiPerWeek)}`);
            setToolTipBody(getPersonalisedTooltipInfoList(emiDetails));
        } else {
            setToolTipTitle(`Weekly payment of ${makePriceLabelRound(emiPerWeek)}`);
            setToolTipBody(getTooltipInfoList(emiDetails, isUserZeroDpVariant).concat(<BottomLink />));
        }
    }, [emiPerWeek, emiDetails, personalised, isUserZeroDpVariant]);

    const onClickFinanceInfo = () => {};
    return (
        <div styleName={"styles.bottomInfoWrapper"}>
            <div styleName={"styles.leftContentWrap"}>
                <h3 styleName={"styles.carName"}>{carName}</h3>
                <div styleName={"styles.carSpecificationWrap"}>
                    <p styleName={"styles.specificationTab"}>{makeOdometerLabelAU(odometerReading)}</p>
                    <p styleName={"styles.specificationTab"}>{bodyType}</p>
                    <p styleName={"styles.specificationTab"}>{transmissionType}</p>
                    <p styleName={"styles.specificationTab"}>{variant}</p>
                </div>
            </div>
            <div styleName={"styles.rightContentWrap"}>
                <div styleName={"styles.amountWrapper"}>
                    <p styleName={"styles.amount"}>
                        {(tradeIn && tradeInToggleSelected) ? makePriceLabelRound(tradeCarPrice) : carPrice.label }
                        <span>Excl. Govt. Charges</span>
                    </p>
                    {/* tradein info */}
                    {tradeIn && tradeInToggleSelected !== null && <div styleName={"styles.tradeInAmount"}>
                        <p styleName={"styles.tradeInWrapper"}>
                            Trade-in price
                            <span styleName={"styles.switchToggle"}>
                                <TradeInYourCarToggleButtonRevamp carId={carId} />
                            </span>
                        </p>
                        {tradeInToggleSelected && <p styleName={"styles.tradeInPrice"}>-{makePriceLabelRound(tradeInAmount)}</p>}
                    </div>}
                </div>
                <div styleName={"styles.amountPerWeekWrap"}>
                    <p styleName={"styles.amountperWeek"}>
                        {makePriceLabelRound(emiPerWeek)}/week
                        <Tooltip customStyleHeading={true} heading={toolTipTitle} body={toolTipBody} onClickCallback={onClickFinanceInfo}>
                            <img src={InfoIcon} hight="16" width="16" alt="Weekly Payment" />
                        </Tooltip>
                    </p>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = ({
    carDetails: {
        content
    },
    user: {isUserZeroDpVariant},
    tradeIn: {
        userTradeInData,
        tradeInToggleSelected
    },
    deliveryInfo,
    checkout: {
        order,
        personalDetails,
        order: { orderId}
    }
}) => ({
    content,
    deliveryInfo,
    order,
    userTradeInData,
    tradeInToggleSelected,
    isUserZeroDpVariant,
    personalDetails,
    orderId
});

VehicleInfoSection.propTypes = {
    content: PropTypes.object,
    isUserZeroDpVariant: PropTypes.bool,
    userTradeInData: PropTypes.object,
    tradeInToggleSelected: PropTypes.bool,
    order: PropTypes.object,
    deliveryInfo: PropTypes.object,
    loanCalculatorInfo: PropTypes.object,
    carId: PropTypes.number
};

export default connect(mapStateToProps)(VehicleInfoSection);
